import { render, staticRenderFns } from "./ForceLogout.vue?vue&type=template&id=37943ac4&scoped=true"
import script from "./ForceLogout.vue?vue&type=script&lang=js"
export * from "./ForceLogout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37943ac4",
  null
  
)

export default component.exports